import { createContext } from 'react';

const GenomPlusSurveyContext = createContext<any>(null);

export default GenomPlusSurveyContext;
